import React, { useState, useEffect } from "react";
import TatToanHopDong from "../SuaTatToan/TatToanHopDong";
import ThongBaoChucNang from "./ThongBaoChucNang";
import TatToanChoDuyetApi from "service/tatToanChoDuyetApi";
export const BtnSuaTatToan = ({ item, SearchDanhSach }) => {
    const initThucHien = {
        duocphep: false,
        thongbao: '',
    };
    const [thuhien, setThucHien] = useState(initThucHien);
    const [isModalVisible, setModalVisible] = useState(false);
    const setModalTatToanHopDongShow = () => {
        //setModalVisible(!isModalVisible);
        CheckThucHien();
    }

    const CheckThucHien = () => {
        TatToanChoDuyetApi.phanQuyenTatToanChoDuyetTheoChucNang("", 2, item.TatToanChoDuyetID).then((response) => {
            setThucHien({
                ...thuhien,
                duocphep: response.data.ThucHien,
                thongbao: response.data.Message,
            });
            setModalVisible(!isModalVisible);
        });
    }

    return (
        <>
            <a onClick={setModalTatToanHopDongShow} href={() => false} className="blue btn-link" title="Sửa tất toán">
               <img src="/app-assets/images/icon-edit-v2.png" />
            </a>
            {isModalVisible && thuhien.duocphep && (
                <TatToanHopDong
                    show={isModalVisible}
                    onHide={setModalTatToanHopDongShow}
                    item={item}
                    SearchDanhSach= {SearchDanhSach}
                ></TatToanHopDong>
            )}
            {isModalVisible && !thuhien.duocphep && (
                <ThongBaoChucNang
                    show={isModalVisible}
                    onHide={setModalTatToanHopDongShow}
                    item={thuhien}
                ></ThongBaoChucNang>
            )}
        </>
    );
};
